import React from 'react';
import { connect } from 'react-redux';

import {
    changeView
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

class AddItems extends React.Component {
    constructor(props) {
        super(props);
        
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="addItems">
                <div className="row">
                    <div className="col-md-4">
                        <button onClick={() => this.props.changeView({ view: "Membership" })}>Add Membership</button>
                    </div>
                    <div className="col-md-4">
                        <button onClick={() => this.props.changeView({ view: "RenewMembership" })}>Renew Membership</button>
                    </div>
                    <div className="col-md-4">
                        <button onClick={() => this.props.changeView({view: "Subscription"})}>Add Subscription</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <button onClick={() => this.props.changeView({ view: "Renew Subscription" })}>Renew Subscription</button>
                    </div>
                    <div className="col-md-4">
                        <button onClick={() => this.props.changeView({view: "ProductOrder"})}>Add Product Order</button>
                    </div>
                    <div className="col-md-4">
                        <button onClick={() => this.props.changeView({ view: "Donation" })}>Add Donation</button>
                    </div>
                </div>
                <div className="row">
                <div className="col-md-4">
                        <button onClick={() => this.props.changeView({ view: "AdditionalDues" })}>Additional Dues</button>
                    </div>
                    <div className="col-md-4">
                        <button disabled>Upgrade Membership</button>
                    </div>
                    <div className="col-md-4">
                        <button disabled>Add Sponsorship</button>
                    </div>
                  
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    changeView
})(AddItems);